import { render, staticRenderFns } from "./HomeworkPlaning.vue?vue&type=template&id=bdb9a408&scoped=true"
import script from "./HomeworkPlaning.vue?vue&type=script&lang=js"
export * from "./HomeworkPlaning.vue?vue&type=script&lang=js"
import style0 from "./HomeworkPlaning.vue?vue&type=style&index=0&id=bdb9a408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb9a408",
  null
  
)

export default component.exports